import {
    GA_COMMUNITY_GUIDELINES_CLICKED,
    GA_EVENTBRITE,
    GA_PRIVACY_POLICY_CLICKED,
    GA_TERMS_OF_SERVICE_CLICKED,
} from '../constants/analytics';
import { IAllContextsProps } from '../constants/interfaces';
import { getQuerySourceProvider } from '../utils/tos';
import { trackGeneralAuthAction } from './general';
import { IAnalyticsDimensionsProps } from './interfaces';
import { capitalize } from './utils';

export const trackTermsOfServiceClicked = ({
    analytics,
}: {
    analytics: IAnalyticsDimensionsProps;
}) => {
    trackGeneralAuthAction({ analytics, action: GA_TERMS_OF_SERVICE_CLICKED });
};

export const trackCommunityGuidelinesClicked = ({
    analytics,
}: {
    analytics: IAnalyticsDimensionsProps;
}) => {
    trackGeneralAuthAction({
        analytics,
        action: GA_COMMUNITY_GUIDELINES_CLICKED,
    });
};

export const trackPrivacyPolicyClicked = ({
    analytics,
}: {
    analytics: IAnalyticsDimensionsProps;
}) => {
    trackGeneralAuthAction({ analytics, action: GA_PRIVACY_POLICY_CLICKED });
};

export const trackToSAction = ({
    action,
    trackLabel,
    contexts,
    routing,
}: {
    action: string;
    trackLabel?: string | null;
    contexts: IAllContextsProps;
    routing?: any; // Needed from redux routing apparently
}) => {
    const socialProvider = trackLabel
        ? trackLabel
        : getQuerySourceProvider({ routing, contexts });

    const label =
        socialProvider && socialProvider !== 'None'
            ? capitalize(socialProvider)
            : GA_EVENTBRITE;

    trackGeneralAuthAction({
        analytics: contexts.configContext?.analytics,
        action,
        label,
    });
};
